import { gql } from '@apollo/client'

const REOPEN_BRAND_CURATION_TASK_MUTATION = gql`
  mutation reopenBrandCurationTask($id: ID!) {
    reopenBrandCurationTask(id: $id) {
      id
      taskStatus
      isCurationDone
      isQaDone
      isQcDone
      isReopenedManually
    }
  }
`

export default REOPEN_BRAND_CURATION_TASK_MUTATION
